export enum ConvoListStyle {
    List = 'list',
    Cards = 'cards',
    Grid = 'grid',
    Combo = 'combo',
}
